export const appName = 'Live Display'
export const companyName = appName + ' Sàrl'
export const companyAddress = 'Le Tombex 6, 1426 Corcelles-près-Concise, Suisse'
export const companyAddressLocality = 'Corcelles-près-Concise'
export const companyAddressRegion = 'Vaud'
export const companyAddressPostalCode = '1426'
export const companyAddressCountry = 'CH'
export const companyVatNumber = 'CHE-440.255.040'
export const companyFoundingDate = '2024'
export const companyContactEmail = 'contact@live-display.pro'
export const companyContactPhone = '+41 78 440 11 21'
export const companyOpeningHours = 'Du lundi au vendredi, de 08h00 à 18h00'
export const appTitle = 'Diaporama pour vos écrans'

export const appLogoAlt = `Logo ${appName}`
export const appLogoUrl = '/images/logo.webp'
// TODO SEO: replace with a dedicated 1200×630 PNG/JPG social banner (logo + tagline + product visual) at /images/og-cover.png. Used for Slack/LinkedIn/Twitter/Facebook share previews.
export const appOgImageUrl = '/images/logo.webp'

export const appTaglineShort = 'Animez vos écrans, captivez vos clients'
export const appTaglineLong = 'Animez vos écrans, captivez vos clients.'

export const appDescriptionShort = 'Diffusez vos photos, vidéos et messages sur tous vos écrans. Sans installation, sans technique.'
export const appDescriptionLong = `${appDescriptionShort} ${appName} est le logiciel suisse pour gérer vos écrans à distance, en quelques clics, accompagné de notre box.`

export const appSeoKeywords = [
  'affichage dynamique',
  'affichage dynamique Suisse',
  'logiciel affichage dynamique',
  'digital signage',
  'digital signage Suisse',
  'écran d\'affichage dynamique',
  'box affichage dynamique',
  'écran professionnel entreprise',
  'écran vitrine commerce',
  'communication sur écran',
  'signalétique numérique'
]

export const partnerBeecolor = {
  name: 'Beecolor',
  legalName: 'Beecolor SA',
  url: 'https://www.beecolor.ch/',
  logoUrl: '/images/partner.png',
  description: 'Nous coordonnons votre projet de bout en bout et confions la fourniture, la pose et l\'installation de vos écrans à notre partenaire suisse Beecolor.',
  strengths: [
    'Un seul interlocuteur\u00A0: l\'équipe Live Display',
    'Pose et fixation professionnelle, partout en Suisse',
    'Maintenance et service après-vente réactif'
  ]
}
